"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReferrerTagAndUtmTagsFromReferrer = exports.getReferrerTagsAndUtmTagsFromUrlSearchParams = exports.getReferrerTagAndUtmTagsFromParamsObject = void 0;
const allowedUtmParams = [
    "utm_content",
    "utm_source",
    "utm_channel",
    "utm_medium",
    "utm_campaign",
    "utm_terms",
];
const getReferrerTagAndUtmTagsFromParamsObject = (params) => {
    const referrerTag = params.referer || undefined;
    const utmTags = Object.entries(params)
        .filter(([key]) => allowedUtmParams.includes(key))
        .map(([key, value]) => `${key}=${value || ""}`)
        .join("&") || undefined;
    if (params.utm_medium) {
        if (!params.utm_channel) {
            params.utm_channel = params.utm_medium;
        }
        delete params.utm_medium;
    }
    const utmTagsObject = {};
    allowedUtmParams.forEach((key) => {
        if (params[key]) {
            utmTagsObject[key.replace(/^utm_/, "")] = params[key];
        }
    });
    return {
        referrerTag,
        utmTags,
        utmTagsObject,
    };
};
exports.getReferrerTagAndUtmTagsFromParamsObject = getReferrerTagAndUtmTagsFromParamsObject;
const getReferrerTagsAndUtmTagsFromUrlSearchParams = (urlSearchParams) => {
    const urlSarchParamsObject = {};
    urlSearchParams.forEach((value, key) => {
        urlSarchParamsObject[key] = value;
    });
    return (0, exports.getReferrerTagAndUtmTagsFromParamsObject)(urlSarchParamsObject);
};
exports.getReferrerTagsAndUtmTagsFromUrlSearchParams = getReferrerTagsAndUtmTagsFromUrlSearchParams;
const getReferrerTagAndUtmTagsFromReferrer = (referrer) => {
    const referrerTag = Array.isArray(referrer) ? referrer[0] : referrer;
    if (!referrerTag) {
        return {
            referrerTag: undefined,
            utmTags: undefined,
            utmTagsObject: {},
        };
    }
    const referrerTagArray = referrerTag.split("_");
    const utmTagsObject = {
        source: referrerTagArray[0],
        channel: referrerTagArray[1],
        content: referrerTagArray[2],
        campaign: referrerTagArray[3],
    };
    const utmTags = Object.entries(utmTagsObject)
        .map(([key, value]) => `utm_${key}=${value || ""}`)
        .join("&");
    Object.keys(utmTagsObject).forEach((key) => {
        if (!utmTagsObject[key]) {
            delete utmTagsObject[key];
        }
    });
    return {
        referrerTag,
        utmTags,
        utmTagsObject,
    };
};
exports.getReferrerTagAndUtmTagsFromReferrer = getReferrerTagAndUtmTagsFromReferrer;
